import React, { lazy } from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { CTAButton } from '../ui/CTAButton';
import { CheckIcon, StarIcon, SparklesIcon } from 'lucide-react';
export function PricingSection() {
  return <SectionWrapper id="precios" withGlow data-id="element-206">
      <div className="max-w-5xl mx-auto" data-id="element-207">
        <div className="text-center mb-16" data-id="element-208">
          <p className="text-[#c9a84c] text-sm font-semibold tracking-[0.2em] uppercase mb-4" data-id="element-209">
            Tu transformación comienza con una decisión
          </p>
          <p className="text-[#9a9aab] text-sm tracking-[0.15em] uppercase mb-6" data-id="element-210">
            Elige tu nivel de acceso
          </p>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-[#e8e6e1] mb-4" data-id="element-211">
            Tres opciones.{' '}
            <span className="text-gold-gradient" data-id="element-212">Una transformación.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-4 lg:gap-6 items-stretch" data-id="element-213">
          {/* Plan Esencial — $14.99 */}
          <div className="flex flex-col rounded-2xl border border-[#252b45] bg-[#0d1321]/80 p-8 relative" data-id="element-214">
            {/* Product Image */}
            <div className="flex justify-center mb-6" data-id="element-215">
              <img src="https://cdn.magicpatterns.com/uploads/qNm8SRAUP9Qo48nmrRgzcq/heylloyd-image-1771185209240.png" alt="Plan Esencial - Ebook" className="h-32 object-contain drop-shadow-[0_0_15px_rgba(201,168,76,0.15)]" loading="lazy" decoding="async" data-id="element-216" />
            </div>

            <div className="mb-8" data-id="element-217">
              <h3 className="font-display text-xl font-bold text-[#e8e6e1] mb-2" data-id="element-218">
                Plan Esencial
              </h3>
              <div className="flex items-baseline gap-1 mb-3" data-id="element-219">
                <span className="font-display text-4xl font-bold text-[#e8e6e1]" data-id="element-220">
                  $14.99
                </span>
                <span className="text-[#6b6b7b] text-sm" data-id="element-221">USD</span>
              </div>
              <p className="text-[#9a9aab] text-sm" data-id="element-222">
                Para quienes quieren comenzar
              </p>
            </div>

            <ul className="space-y-3 mb-8 flex-1" role="list" data-id="element-223">
              <li className="flex items-start gap-3" data-id="element-224">
                <CheckIcon className="w-4 h-4 text-[#c9a84c] mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-225" />
                <span className="text-[#9a9aab] text-sm" data-id="element-226">Ebook completo</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-227">
                <CheckIcon className="w-4 h-4 text-[#c9a84c] mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-228" />
                <span className="text-[#9a9aab] text-sm" data-id="element-229">
                  Protocolo de 21 días
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-230">
                <CheckIcon className="w-4 h-4 text-[#c9a84c] mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-231" />
                <span className="text-[#9a9aab] text-sm" data-id="element-232">
                  Acceso de por vida
                </span>
              </li>
            </ul>

            <a href="https://pay.hotmart.com/A104469088E" target="_blank" rel="noopener noreferrer" className="w-full py-3.5 rounded-lg border border-[#252b45] text-[#9a9aab] font-medium text-sm text-center block
                hover:border-[#c9a84c]/40 hover:text-[#e8e6e1] transition-all duration-300
                focus:outline-none focus:ring-2 focus:ring-[#c9a84c]/50 focus:ring-offset-2 focus:ring-offset-[#0a0e1a]
                cursor-pointer" style={{
            textDecoration: 'none'
          }} aria-label="Comenzar ahora con Plan Esencial" data-id="element-233">
              Comenzar ahora
            </a>
          </div>

          {/* Sistema Completo — $27 (MÁS ELEGIDO) */}
          <div className="flex flex-col rounded-2xl border-2 border-[#c9a84c] bg-[#0d1321] p-8 relative md:scale-105 md:-my-4 shadow-[0_0_40px_rgba(201,168,76,0.15)]" data-id="element-234">
            {/* Badge */}
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 z-10" data-id="element-235">
              <div className="flex items-center gap-1.5 px-4 py-1.5 bg-gradient-to-r from-[#c9a84c] to-[#f0d060] rounded-full" data-id="element-236">
                <StarIcon className="w-3.5 h-3.5 text-[#0a0e1a]" fill="currentColor" aria-hidden="true" data-id="element-237" />
                <span className="text-[#0a0e1a] text-xs font-bold tracking-wider uppercase" data-id="element-238">
                  Más Elegido
                </span>
              </div>
            </div>

            {/* Product Image */}
            <div className="flex justify-center mb-6 mt-2" data-id="element-239">
              <img src="https://cdn.magicpatterns.com/uploads/6bobP5j1d5SyZvE5wtaGuP/heylloyd-image-1771185344718.png" alt="Sistema Completo - Ebook + Audio" className="h-36 object-contain drop-shadow-[0_0_20px_rgba(201,168,76,0.25)]" loading="lazy" decoding="async" data-id="element-240" />
            </div>

            <div className="mb-8 mt-2" data-id="element-241">
              <h3 className="font-display text-xl font-bold text-[#c9a84c] mb-2" data-id="element-242">
                Sistema Completo
              </h3>
              <div className="flex items-baseline gap-1 mb-1" data-id="element-243">
                <span className="font-display text-5xl font-bold text-gold-gradient" data-id="element-244">
                  $27
                </span>
                <span className="text-[#c9a84c] text-sm" data-id="element-245">USD</span>
              </div>
              <p className="text-[#6b6b7b] text-sm line-through mb-1" data-id="element-246">
                Valor real: $297 USD
              </p>
              <p className="text-[#e8e6e1] text-sm font-medium" data-id="element-247">
                El sistema completo para instalar tu nueva identidad
              </p>
              <p className="text-[#c9a84c] text-xs font-semibold mt-2 tracking-wide" data-id="element-248">
                El sistema más elegido por nuestros usuarios
              </p>
            </div>

            <ul className="space-y-3 mb-8 flex-1" role="list" data-id="element-249">
              <li className="flex items-start gap-3" data-id="element-250">
                <CheckIcon className="w-4 h-4 text-[#c9a84c] mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-251" />
                <span className="text-[#e8e6e1] text-sm font-medium" data-id="element-252">
                  Ebook completo
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-253">
                <CheckIcon className="w-4 h-4 text-[#c9a84c] mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-254" />
                <span className="text-[#e8e6e1] text-sm font-medium" data-id="element-255">
                  Audiobook completo (+50 minutos)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-256">
                <CheckIcon className="w-4 h-4 text-[#c9a84c] mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-257" />
                <span className="text-[#e8e6e1] text-sm font-medium" data-id="element-258">
                  10 bonos de implementación
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-259">
                <CheckIcon className="w-4 h-4 text-[#c9a84c] mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-260" />
                <span className="text-[#e8e6e1] text-sm font-medium" data-id="element-261">
                  Sistema de integración
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-262">
                <CheckIcon className="w-4 h-4 text-[#c9a84c] mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-263" />
                <span className="text-[#e8e6e1] text-sm font-medium" data-id="element-264">
                  Acceso de por vida
                </span>
              </li>
            </ul>

            <CTAButton showArrow={false} className="w-full" data-id="element-265">
              Acceder al sistema completo
            </CTAButton>

            <p className="text-[#6b6b7b] text-xs text-center mt-3" data-id="element-266">
              91% de descuento · Pago único
            </p>
          </div>

          {/* Sistema NEXUS — $37 (BRIGHTER, not bigger) */}
          <div className="flex flex-col rounded-2xl p-8 relative bg-[#0d1321]/80" style={{
          border: '1.5px solid transparent',
          backgroundClip: 'padding-box',
          boxShadow: '0 0 25px rgba(201,168,76,0.12), 0 0 50px rgba(201,168,76,0.06), inset 0 0 20px rgba(201,168,76,0.03)'
        }} data-id="element-267">
            {/* Gold shimmer border overlay */}
            <div className="absolute inset-0 rounded-2xl pointer-events-none" style={{
            border: '1.5px solid rgba(201,168,76,0.45)',
            borderRadius: 'inherit'
          }} aria-hidden="true" data-id="element-268" />

            {/* Subtle glow at top */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-24 pointer-events-none" style={{
            background: 'radial-gradient(ellipse at center, rgba(201,168,76,0.1) 0%, transparent 70%)'
          }} aria-hidden="true" data-id="element-269" />

            {/* NEXUS badge */}
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 z-10" data-id="element-270">
              <div className="flex items-center gap-1.5 px-4 py-1.5 bg-[#0d1321] border border-[#c9a84c]/50 rounded-full shadow-[0_0_15px_rgba(201,168,76,0.2)]" data-id="element-271">
                <SparklesIcon className="w-3.5 h-3.5 text-[#f0d060]" aria-hidden="true" data-id="element-272" />
                <span className="text-[#f0d060] text-xs font-bold tracking-wider uppercase gold-shimmer" data-id="element-273">
                  NEXUS
                </span>
              </div>
            </div>

            {/* Product Image */}
            <div className="flex justify-center mb-6 mt-2" data-id="element-274">
              <img src="https://cdn.magicpatterns.com/uploads/rgFVDCDuF2GSCMQwuPwg5Z/private_openrouter-generated-image-1771189315301.png" alt="Sistema NEXUS - Todo incluido" className="h-36 object-contain drop-shadow-[0_0_25px_rgba(201,168,76,0.4)]" loading="lazy" decoding="async" data-id="element-275" />
            </div>

            <div className="mb-8 mt-2 relative" data-id="element-276">
              <h3 className="font-display text-xl font-bold gold-shimmer mb-2" data-id="element-277">
                Sistema NEXUS
              </h3>
              <div className="flex items-baseline gap-1 mb-1" data-id="element-278">
                <span className="font-display text-4xl font-bold text-[#f0d060]" data-id="element-279">
                  $37
                </span>
                <span className="text-[#c9a84c] text-sm" data-id="element-280">USD</span>
              </div>
              <p className="text-[#e8e6e1] text-sm font-medium mb-1" data-id="element-281">
                El nivel más profundo de reprogramación mental y espiritual
              </p>
              <p className="text-[#c9a84c] text-xs font-semibold tracking-wide" data-id="element-282">
                Incluye la reprogramación subconsciente completa
              </p>
            </div>

            <ul className="space-y-3 mb-8 flex-1 relative" role="list" data-id="element-283">
              <li className="flex items-start gap-3" data-id="element-284">
                <CheckIcon className="w-4 h-4 text-[#f0d060] mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-285" />
                <span className="text-[#e8e6e1] text-sm" data-id="element-286">
                  Todo lo del Sistema Completo
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-287">
                <CheckIcon className="w-4 h-4 text-[#f0d060] mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-288" />
                <span className="text-[#e8e6e1] text-sm" data-id="element-289">
                  7 audios de reprogramación subconsciente
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-290">
                <CheckIcon className="w-4 h-4 text-[#f0d060] mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-291" />
                <span className="text-[#e8e6e1] text-sm" data-id="element-292">
                  Integración profunda del nuevo sistema
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-293">
                <CheckIcon className="w-4 h-4 text-[#f0d060] mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-294" />
                <span className="text-[#e8e6e1] text-sm" data-id="element-295">
                  Acceso de por vida
                </span>
              </li>
            </ul>

            <a href="https://pay.hotmart.com/T104469443H" target="_blank" rel="noopener noreferrer" className="relative w-full py-3.5 rounded-lg font-medium text-sm text-center block
                text-[#0a0e1a] bg-gradient-to-r from-[#c9a84c] via-[#f0d060] to-[#c9a84c] bg-[length:200%_auto]
                hover:bg-[position:right_center] hover:shadow-[0_0_25px_rgba(240,208,96,0.5)]
                transition-all duration-500
                focus:outline-none focus:ring-2 focus:ring-[#f0d060] focus:ring-offset-2 focus:ring-offset-[#0a0e1a]
                cursor-pointer" style={{
            textDecoration: 'none'
          }} aria-label="Acceder a NEXUS" data-id="element-296">
              ⭐ Acceder a NEXUS ⭐
            </a>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}